import * as React from "react";
import DeviceContext from "../../service/indentifyDevice";
import EdelLogo from "./../../../assets/icons/svgIcons/logo";
import { TSubmitState } from "./leadForm";
import { ThankYouSvg } from "./../../../assets/icons/svgIcons/thankYouSvg";
import EdButton from "../../generic/edButton";

export interface LeadModalProps {
	onClose: () => void;
	state: TSubmitState | undefined;
	retry: () => void;
}

const LeadModal: React.FC<LeadModalProps> = ({ onClose, children, state = "initiated", retry }) => {
	const [styles, setStyles] = React.useState({} as any);

	React.useEffect(() => {
		if (DeviceContext().isDesktop) {
			import("../../../assets/scss/components/leadPages/leadForm/leadModalDsk.module.scss").then((style) => {
				setStyles(style.default);
			});
		} else {
			import("../../../assets/scss/components/leadPages/leadForm/leadModalMob.module.scss").then((style) => {
				setStyles(style.default);
			});
		}
	}, []);

	return Object.keys(styles).length ? (
		<div className={styles.overlay}>
			<div className={styles.modal_cont + " " + (state === "success" || state === "error" ? styles.small : "")}>
				<div className={styles.modal + " " + (state === "success" || state === "error" ? styles.modal_succ : "")}>
					{state === "initiated" || state === "submitted" ? (
						<div className={styles.form_cont}>
							{!DeviceContext().isDesktop && <EdelLogo fill="#003e92" width="115" height="17" viewbox="5 7 115 17" />}
							{!DeviceContext().isDesktop && <i className={`edel-icon-close ${styles.close}`} onClick={onClose} />}
							<h2 className={styles.title}>We shall get in touch with you & help you invest</h2>
							<p className={styles.sub_title}>Quick, Fast and simple</p>
							{children}
							{DeviceContext().isDesktop && (
								<button onClick={onClose} className={styles.cancel}>
									Cancel
								</button>
							)}
						</div>
					) : state === "success" ? (
						<div className={styles.success}>
							<ThankYouSvg width="125" height="125" />
							<h2 className={styles.title}>Thank you!</h2>
							<p className={styles.sub_title}>We’ll be in touch with you shortly</p>
						</div>
					) : (
						<div className={styles.error}>
							<div className={styles.error}>
								<div className={styles.circle}>
									<i className={`edel-icon-exclamation ${styles.exclamation}`} />
								</div>
								<p className={styles.sub_title}>There was an error trying to process your request. Please try again.</p>
							</div>
							<EdButton btnTyp="primary" value="Retry" className={styles.retry} onClick={retry} />
							<button onClick={onClose} className={styles.cancel}>
								Cancel
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	) : (
		<></>
	);
};

export default LeadModal;
